import { useState } from "react";
import { Lock, MessageCircle, Download } from "lucide-react";
import { IoMdArrowBack } from "react-icons/io";

const categories = [
    { id: 1, value: "WHEELED ADVENTURES" },
    { id: 2, value: "FUNNY" },
    { id: 3, value: "EDUCATION" },
    { id: 4, value: "ENTERTAINMENT" },
    { id: 5, value: "FILM & ANIMATION" },
    { id: 6, value: "GAMING" },
    { id: 7, value: "HOWTO & STYLE" },
    { id: 8, value: "MOTIVATIONAL" },
    { id: 9, value: "FOOD AND COOKING" },
    { id: 10, value: "MUSIC" },
    { id: 11, value: "NEWS & POLITICS" },
    { id: 12, value: "NONPROFITS & ACTIVISM" },
    { id: 13, value: "PEOPLE & BLOGS" },
    { id: 14, value: "NATURE AND ANIMALS" },
    { id: 15, value: "SCIENCE & TECHNOLOGY" },
    { id: 16, value: "SPORTS" },
    { id: 17, value: "ADVENTURE" },
    { id: 18, value: "PARENTING AND KIDS" },
];

const VideoForm = ({
    description,
    setDescription,
    handleDraftClick,
    selectedCategory,
    setSelectedCategory,
    isPrivate,
    onPrivateToggle,
    allowComments,
    setAllowComments,
    allowDownload,
    setAllowDownload,
    onPostVideo,
    isUploadingToS3,
    isPosting,
    uploadProgress,
    uploadError,
    onCancelUpload,
    customThumbnailPreview,
    thumbnailInputRef,
    onRemoveThumbnail,
    isSavingDraft,
    handleSaveToStorageDraft
}) => {
    const toggleButtons = [
        { id: "private", label: "Private", icon: <Lock size={18} />, state: isPrivate, onChange: onPrivateToggle },
        { id: "comment", label: "Allow comments", icon: <MessageCircle size={18} />, state: allowComments, onChange: () => setAllowComments(prev => !prev) },
        { id: "download", label: "Allow viewer to download video", icon: <Download size={18} />, state: allowDownload, onChange: () => setAllowDownload(prev => !prev) },
    ];

    return (
        <>
            {/* Scrollable content — stops above the sticky bottom buttons */}
            <div className="absolute top-[19rem] left-0 right-0 bottom-[3.5rem] overflow-y-auto px-4 space-y-2 py-3">
                {/* Caption */}
                <div>
                    <textarea
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="Add a caption..."
                        className="w-full h-20 p-3 bg-gray-100 dark:bg-[#333333] rounded-lg resize-none text-sm focus:outline-none focus:ring-2 focus:ring-[#BDE6FF] dark:border-[#444444] text-black dark:text-white"
                    />
                </div>

                {/* Thumbnail */}
                {/* <div className="flex items-center justify-between px-3 py-3 bg-white dark:bg-[#1a1a1a] border-2 border-[#BDE6FF] rounded-xl">
                    <div className="flex items-center gap-3">
                        <div className="flex items-center justify-center w-6 h-6">
                            {customThumbnailPreview ? (
                                <img src={customThumbnailPreview} alt="thumbnail" className="w-6 h-6 rounded object-cover" />
                            ) : (
                                <svg className="w-5 h-5 text-gray-700 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <rect x="3" y="3" width="18" height="18" rx="2" strokeWidth="2" />
                                    <path d="M3 9l4-4 4 4 4-6 4 6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor" stroke="none" />
                                </svg>
                            )}
                        </div>
                        <div className="flex-1">
                            <p className="text-[14px] font-semibold dark:text-white">Thumbnail</p>
                            <p className="text-[11px] text-gray-500 dark:text-gray-400">
                                {customThumbnailPreview ? "Custom thumbnail selected" : "Add a custom thumbnail"}
                            </p>
                        </div>
                    </div>
                    <div className="flex items-center gap-2">
                        {customThumbnailPreview && (
                            <button
                                type="button"
                                onClick={onRemoveThumbnail}
                                className="text-[11px] text-red-500 font-semibold"
                            >
                                Remove
                            </button>
                        )}
                        <button
                            type="button"
                            onClick={() => thumbnailInputRef?.current?.click()}
                            className="text-[12px] font-semibold text-black dark:text-white bg-[#BDE6FF] hover:bg-[#9dd5f0] px-3 py-1 rounded-full"
                        >
                            {customThumbnailPreview ? "Change" : "Add"}
                        </button>
                    </div>
                </div> */}

                {/* Toggle Buttons */}
                {toggleButtons.map((button) => (
                    <div key={button.id} className="flex justify-between items-center py-1.5 bg-white dark:bg-[#1E1D21]">
                        <div className="flex items-center gap-3">
                            <div className="text-black dark:text-white">{button.icon}</div>
                            <p className="text-[14px] font-medium text-black dark:text-white">{button.label}</p>
                        </div>
                        <label className="relative inline-flex cursor-pointer select-none items-center">
                            <input
                                type="checkbox"
                                className="sr-only"
                                checked={button.state}
                                onChange={button.onChange}
                            />
                            <span className={`flex h-[22px] w-[42px] items-center rounded-full p-1 duration-200 ${button.state ? "bg-[#BDE6FF]" : "bg-[#D1D1D6]"}`}>
                                <span className={`h-[16px] w-[16px] rounded-full bg-white dark:bg-[#333333] duration-200 shadow-md ${button.state ? "translate-x-[18px]" : ""}`} />
                            </span>
                        </label>
                    </div>
                ))}
            </div>

            {/* Sticky bottom buttons */}
            <div className="absolute bottom-0 left-0 right-0 flex flex-col gap-y-2 px-4 py-3 bg-white dark:bg-[#1E1D21] border-t border-gray-200 dark:border-gray-800/50 z-10">
                {uploadError && (
                    <p className="text-center text-[12px] text-red-500">{uploadError}</p>
                )}
                <div className="flex items-center gap-x-3">
                    <button
                        onClick={handleSaveToStorageDraft}
                        disabled={isUploadingToS3 || isPosting}
                        className="flex-1 rounded-xl text-[14px] font-semibold h-10 relative overflow-hidden bg-white dark:bg-[#333333] text-black dark:text-white border border-gray-300 dark:border-gray-800/50 hover:bg-gray-50 dark:hover:bg-[#444444] disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {isSavingDraft ? "Saving..." : "Save to Drafts"}
                    </button>

                    {(isUploadingToS3 || isPosting) ? (
                        <>
                            <button
                                disabled
                                className="flex-1 rounded-xl text-[14px] font-semibold h-10 relative overflow-hidden bg-[#BDE6FF] text-black cursor-not-allowed"
                            >
                                <div
                                    className="absolute left-0 top-0 h-full bg-[#7dcfee] transition-all duration-300"
                                    style={{ width: `${isPosting ? 100 : uploadProgress}%` }}
                                />
                                <span className="relative z-10">
                                    {isPosting ? "Posting..." : `Uploading... ${uploadProgress}%`}
                                </span>
                            </button>
                            <button
                                onClick={onCancelUpload}
                                className="rounded-xl text-[13px] font-semibold h-10 px-3 bg-red-100 hover:bg-red-200 text-red-700"
                            >
                                Cancel
                            </button>
                        </>
                    ) : (
                        <button
                            onClick={onPostVideo}
                            className="flex-1 rounded-xl text-[14px] font-semibold h-10 relative overflow-hidden bg-[#BDE6FF] hover:bg-[#9dd5f0] text-black"
                        >
                            Post Video
                        </button>
                    )}
                </div>
            </div>
        </>
    );
};

export default VideoForm;
